@for (file of ( uploadData?.files | async ); track file; let i = $index) {
  <div class="upload-item">
    <div class="upload-item-content">
      <div class="filename">
        <i class="ionicon ion-ios-copy"></i>
        <span>{{ file.name }}</span>
      </div>
      <div class="progress-content">
        <div class="progress">
          <span class="bar" [style.width]="getPercentage(file) + '%'" [class.is-done]="getPercentage(file) === 100"></span>
        </div>
      </div>
      <div class="progress-text-content">
        <span class="progress-text" [class.is-done]="getPercentage(file) === 100">
          <span>{{ getPercentage(file) }}% </span>
          @if (getPercentage(file) !== 100) {
            <span>{{ 'upload_progress_bar.uploading' | translate }}</span>
          }
          @if (getPercentage(file) === 100) {
            <span>{{ 'upload_progress_bar.ready' | translate }}</span>
          }
        </span>
        @if (getPercentage(file) !== 0 && getPercentage(file) !== 100) {
          <span class="speed-and-eta-text">
            <span>{{ 'generic.per_second' | translate: { amount: getSpeed(file) | bytes } }} </span>
            <span>
              {{ 'upload_progress_bar.eta' | translate: {
              eta: hasEta(file)
              ? (getEta(file) | from_now | async)
              : ('generic.unknown' | translate)
              } }}
            </span>
          </span>
        }
      </div>
    </div>
  </div>
}
